<template>
    <div class="community_share_wrap">
        <el-page-header @back="$core.goBack" ></el-page-header>
        <div class="community_share_content">
             <!-- tab栏 -->
            <div class="project_tab">
                <ul>
                    <li v-for="item in subNav" :key="item.id" :class="{ active: isactive == item.id }" @click="changeTab(item.id)">{{item.title}}</li>
                </ul>
            </div>
            <!-- 上传内容模块 -->
            <div class="updata_content">
                <!-- 源数据 -->
                <div v-if="isactive == 1">
                    <div class="icon_wrap">
                        <i class="iconfont icon-shujuku">&nbsp;源数据分享</i>
                    </div>
                    <div class="form_wrap">
                        <el-form :rules="uploadRules" ref="upload" :model="uploadData" label-width="100px">
                            <el-form-item label="数据名称:" prop="title">
                                <div class="title_input">
                                    <el-input v-model="uploadData.title" placeholder="请输入数据名称"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="封面图片:">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadImgAPI"
                                    :headers="{token:tokenVal}"
                                    :on-success="uploadPoster"
                                    :show-file-list="false">
                                    <el-button type="primary">替换图片</el-button><span style="color:#F56C6C">&nbsp;&nbsp;(请上传分辨率为440*440的png、jpg图片)</span>
                                    <div slot="tip" class="el-upload__tip">再次添加将覆盖掉之前的图片</div>
                                    <!-- <img src="https://msds-html.obs.cn-southwest-2.myhuaweicloud.com:443/community%2F1656580952546pk.png" class="avatar"> -->
                                    <img v-if="uploadData.imageUrl" :src="uploadData.imageUrl" class="avatar">
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="数据概述:" prop="summary">
                                <div>
                                    <el-input type="textarea" placeholder="请输入概述" :autosize="{minRows:5}" :show-word-limit="true" maxlength="200" v-model="uploadData.summary"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="字段描述:">
                                <div class="flex-start">
                                    <el-button style="margin-right:20px" type="primary" @click="downloadTableModel">模板下载</el-button>
                                    <el-upload
                                        class="upload-demo"
                                        :action="uploadTableFile"
                                        :headers="{token:tokenVal}"
                                        :on-success="analysisTable"
                                        :show-file-list="false">
                                        <el-button type="primary">模板上传</el-button>
                                    </el-upload>
                                </div>
                            </el-form-item>
                            <div class="table_wrap">
                                <el-table  border :header-cell-style="$core.tableHeader"  stripe header-align="center" :data="uploadData.tableData">
                                    <el-table-column width="80" align="center" type="index" label="序号"></el-table-column>
                                    <el-table-column align="center" prop="name" label="字段名"></el-table-column>
                                    <el-table-column align="center" prop="type" label="数据类型"></el-table-column>
                                    <el-table-column align="center" prop="description" label="描述"></el-table-column>
                                </el-table>
                            </div>
                            <el-form-item class="mat20" label="数据文件:" prop="fileUrl">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadFileAPI"
                                    :headers="{token:tokenVal}"
                                    :before-upload="limiteUploadFile"
                                    :on-success="uploadShareFile"
                                    :show-file-list="false">
                                    <el-button type="primary">添加文件</el-button>
                                    <div slot="tip" class="el-upload__tip">重新上传将覆盖原文件！</div>
                                </el-upload>

                                <div v-if="uploadData.fileUrl"><a target="_blank" :href="JSON.parse(uploadData.fileUrl).fileUrl">{{JSON.parse(uploadData.fileUrl).name}}</a></div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <!-- 源代码 -->
                <div v-if="isactive == 2">
                    <div class="icon_wrap">
                        <i class="iconfont icon-code">&nbsp;源代码分享</i>
                    </div>
                    <div class="form_wrap">
                        <el-form :model="uploadData" ref="upload" :rules="uploadRules" label-width="120px">
                            <el-form-item label="源代码名称:" prop="title">
                                <div class="title_input">
                                    <el-input v-model="uploadData.title" placeholder="请输入源代码名称"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="封面图片:">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadImgAPI"
                                    :headers="{token:tokenVal}"
                                    :on-success="uploadPoster"
                                    :show-file-list="false">
                                    <el-button type="primary">替换图片</el-button><span style="color:#F56C6C">&nbsp;&nbsp;(请上传分辨率为440*440的png、jpg图片)</span>
                                    <div slot="tip" class="el-upload__tip">再次添加将覆盖掉之前的图片</div>
                                    <!-- <img src="https://msds-html.obs.cn-southwest-2.myhuaweicloud.com:443/community%2F1656580952546pk.png" class="avatar"> -->
                                    <img v-if="uploadData.imageUrl" :src="uploadData.imageUrl" class="avatar">
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="源代码概述:" prop="summary">
                                <div>
                                    <el-input type="textarea" placeholder="请输入概述" :autosize="{minRows:5}" :show-word-limit="true" maxlength="200" v-model="uploadData.summary"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item class="mat20" label="源代码文件:" prop="fileUrl">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadFileAPI"
                                    :headers="{token:tokenVal}"
                                    :on-success="uploadShareFile"
                                    :before-upload="limiteUploadFile"
                                    :show-file-list="false">
                                    <el-button type="primary">添加文件</el-button>
                                    <div slot="tip" class="el-upload__tip">重新上传将覆盖原文件！</div>
                                </el-upload>

                                <div v-if="uploadData.fileUrl"><a target="_blank" :href="JSON.parse(uploadData.fileUrl).fileUrl">{{JSON.parse(uploadData.fileUrl).name}}</a></div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <!-- 分析报告 -->
                <div v-if="isactive == 4">
                    <div class="icon_wrap">
                        <i class="iconfont icon-baogao">&nbsp;分析报告分享</i>
                    </div>
                    <div class="form_wrap">
                        <el-form :model="uploadData" ref="upload" :rules="uploadRules" label-width="140px">
                            <el-form-item label="分析报告名称:" prop="title">
                                <div class="title_input">
                                    <el-input v-model="uploadData.title" placeholder="请输入源代码名称"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="封面图片:">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadImgAPI"
                                    :headers="{token:tokenVal}"
                                    :on-success="uploadPoster"
                                    :show-file-list="false">
                                    <el-button type="primary">替换图片</el-button><span style="color:#F56C6C">&nbsp;&nbsp;(请上传分辨率为440*440的png、jpg图片)</span>
                                    <div slot="tip" class="el-upload__tip">再次添加将覆盖掉之前的图片</div>
                                    <!-- <img src="https://msds-html.obs.cn-southwest-2.myhuaweicloud.com:443/community%2F1656580952546pk.png" class="avatar"> -->
                                    <img v-if="uploadData.imageUrl" :src="uploadData.imageUrl" class="avatar">
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="分析报告概述:" prop="summary">
                                <div>
                                    <el-input type="textarea" placeholder="请输入概述" :autosize="{minRows:5}" :show-word-limit="true" maxlength="200" v-model="uploadData.summary"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item class="mat20" prop="fileUrl" label="分析报告文件:">
                                <el-upload
                                    class="upload-demo"
                                    :action="uploadFileAPI"
                                    :headers="{token:tokenVal}"
                                    :on-success="uploadShareFile"
                                    :before-upload="limiteUploadFile"
                                    :show-file-list="false">
                                    <el-button type="primary">添加文件</el-button>
                                    <div slot="tip" class="el-upload__tip">重新上传将覆盖原文件！</div>
                                    <div slot="tip" class="el-upload__tip">仅支持上传pdf格式文件</div>
                                </el-upload>

                                <div v-if="uploadData.fileUrl"><a target="_blank" :href="JSON.parse(uploadData.fileUrl).fileUrl">{{JSON.parse(uploadData.fileUrl).name}}</a></div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="flex-around ">
                    <el-button type="primary" @click="uploadShareData">提交分享</el-button>
                </div>
            </div>
        </div>
        <el-dialog  :visible.sync="commitVisible" title="注意" width="27%"  center>
            <div class="dialog_content">
                您发布的分享已成功提交，将在系统审核通过后公开，届时我们将通过个人中心 -- 通知页面告知您审核结果。
            </div>
            <div class="flex-around mat20">
                <el-button type="primary" @click="commitVisible = false">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { insertShareFile } from '../../../utils/api';

export default {
    data() {
        return {
            uploadImgAPI: this.$config.SYSTEM_URL + '/msdata/common/file?fileType=SHARED_COMMUNITY',//上传图片
            uploadTableFile: this.$config.SYSTEM_URL + '/msdata/common/uploadTemplate',//上传表格描述文件
            uploadFileAPI: this.$config.SYSTEM_URL + '/msdata/common/dataFile?fileType=SHARED_COMMUNITY',//上传文件
            tokenVal: sessionStorage.getItem('token'),
            isactive: 1,
            commitVisible: false,
            subNav: [{
                id: 1,
                    title:'源数据'
                },{
                    id:2,
                    title:'源代码'
                },{
                    id:4,
                    title:'分析报告'
                }],
                uploadData:{
                    title:'',
                    summary:'',
                    imageUrl:'https://msds-html.obs.cn-southwest-2.myhuaweicloud.com/system/20220713152554.png',
                    dataUrl:'',
                    fileId:'',
                    tableData:[],
                    fileUrl:''
                },
                uploadRules:{
                    title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                    summary: [{ required: true, message: '请输入概述', trigger: 'blur' }],
                    fileUrl: [{ required: true, message: '请上传文件'}],
                }
            }
        },
        created(){},
        watch:{
            isactive:{
                handler(newName,oldName){
                    this.$refs.upload.resetFields()
                    this.uploadData.tableData = []
                    this.uploadData.fileUrl = ''
                }
            }
        },
        methods:{
            //限制文件
            limiteUploadFile(file){
                //限制上传文件大小为100M
                const isLt100M = file.size / 1024 / 1024 < 100;
                if (!isLt100M) {
                    this.$message.error('上传头像图片大小不能超过100MB!');
                    return false
                }
                //如果为分析报告，则限制文件只能是pdf
                if(this.isactive == 4){
                    if(!file.name.includes('pdf')){
                        this.$message.error('分析报告只能上传pdf文件');
                        return false
                    }
                }
            },

            //上传共享社区数据
            uploadShareData(){
                let params = {
                    id:'',
                    title:this.uploadData.title,
                    summary:this.uploadData.summary,
                    imageUrl:this.uploadData.imageUrl,
                    dataUrl:this.uploadData.dataUrl,
                    fileId:this.uploadData.fileId,
                    fieldDescription:JSON.stringify(this.uploadData.tableData),
                    type:this.isactive
                }
                this.$refs.upload.validate(valid => {
                    if(!valid) return
                    insertShareFile(params).then(res => {
                        this.commitVisible = true
                        this.$refs.upload.resetFields()
                        this.uploadData.tableData = []
                        this.uploadData.fileUrl = ''
                    }).catch(err => {})
                })

            },

            //上传封面图片
            uploadPoster(response){
                this.uploadData.imageUrl = response.data
            },

            //上传数据文件
            uploadShareFile(response, file, fileList){
                let obj = {
                    name:file.name,
                    fileUrl:response.data.fileUrl
                }
                this.uploadData.fileUrl = JSON.stringify(obj)
                this.uploadData.fileId = response.data.id
                this.$message.success('文件上传成功！！')
            },

            //解析上传的表格模板
            analysisTable(response, file, fileList){
                this.uploadData.tableData = response.data
                let arr = []
                response.data.map(item => {
                    arr.push([{
                         name:item.name,
                         imgUrl:item.type
                    }])
                })
            },

            //下载模板
            downloadTableModel(){
                location.href = 'https://mssdk-docs.obs.cn-southwest-2.myhuaweicloud.com/MSData_common_model/uploadCase_table_model.xlsx'
            },

            //切换导航栏
            changeTab(id){
                this.isactive = id
            }
        },
    }
</script>
<style lang='scss' scoped>
.dialog_content{
    font-size: 16px;
    line-height: 1.7;
    text-indent: 2rem;
}
.form_wrap{
    .el-upload__tip{
        color: rgb(245, 108, 108);;
    }
    .title_input{
        width: 30%;
    }
    .avatar{
        margin: 15px 0px;
        display: block;
        border-radius: 10px;
        width: 220px;
        height: 220px;
    }
    img{

    }
}
.updata_content{
    .icon_wrap{
        margin: 20px 0px;
        i{
            font-size: 22px;
            color: #5278F7;
            font-weight: bold;
        }

    }
    >div{
        padding: 30px;
    }
}
.community_share_content{
    box-sizing: border-box;
    width: 100%;
    padding: 40px 200px;
}
.active {
    // background: darkcyan;
    border-bottom: 5px solid #5277f7;
    font-size: 25px;
}
.project_tab {
    width: 100%;
    height: 74px;
    border: 2px solid #5277f7;
    border-radius: 20px;
    background: white;
    // margin: 0px 0px ;
    ul {
        width: 80%;
        height: 100%;
        margin-left: calc(20% / 2);
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        li {
            display: block;
            height: 93%;
            width: 120px;
            float: right;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 30px;
            color: #3c3c3c;
            line-height: 74px;
        }
        li:hover{
            cursor: pointer;
            font-size: 25px;
        }
    }
}
</style>
